<template>
  <div>
    <label class="data-label">
      {{ label }}
    </label>
    <custom-text-area
      v-model="model"
      :disabled="disabled"
      :maxlength="max"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'QuestionnaireQuestionText',
  components: { CustomTextArea },
  props: {
    value: {
      type: String,
      default: () => null,
    },
    label: {
      type: String,
      default: () => 'Texto Abierto:',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    max: {
      type: Number,
      default: () => 0,
    },
    placeholder: {
      type: String,
      default: () => 'Escriba un texto',
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style scoped>
div ::v-deep .form-control {
  background-color: #f1f6f4;
}
</style>
